import header from "./man-having-home-automation-control-station.jpg";
import section1 from "./real-estate-agent-giving-couple-keys.jpg";
import section2 from "./real-estate-agent-showing-new-apartment-couple.jpg";
import section3 from "./smiling-realtor-with-keys-folder-new-office.jpg";
import section4 from "./real-estate-agent-giving-keys.jpg";
import section5de from "./searching-new-house-buy-real-estate-website-DE.webp";
import section5en from "./searching-new-house-buy-real-estate-website.jpg";
import section6 from "./businesswoman-applying-company-seal.jpg";
import section7 from "./virtual-open-house-showing.jpg";
import section8 from "./people-filling-out-paper.png";

export {
  header,
  section1,
  section2,
  section3,
  section4,
  section5de,
  section5en,
  section6,
  section7,
  section8,
};
